import React from 'react';
import { Tooltip } from '@mui/material';
import { DropdownButton } from 'components/alove/DropDownButton';
import { BrandManagementProps } from '../types';

const MDTypography = require('components/MDTypography').default;

export const BrandManagement: React.FC<BrandManagementProps & { textColor: string; roles: any[] }> = ({
  allowedBrans,
  currentBrand,
  currentUser,
  onBrandChange,
  textColor,
  roles
}) => {
  const roleTitle = currentUser?.role?.[currentBrand?.id || 0]?.roles
    ?.map((item: number) => roles?.find((role) => role?.id === item)?.roleName)
    .join(", ");

  if (currentUser?.brands?.length === 1) {
    return (
      <>
        <MDTypography
          component="h3"
          variant="button"
          fontWeight="medium"
          color={textColor}
          style={{ fontSize: "18px" }}
        >
          {currentBrand?.name?.toUpperCase()}
        </MDTypography>
        <Tooltip title={roleTitle}>
          <MDTypography
            component="h6"
            variant="button"
            fontWeight="light"
            color={textColor}
            style={{ textOverflow: "ellipsis", width: "150px" }}
          >
            {roleTitle}
          </MDTypography>
        </Tooltip>
      </>
    );
  }

  return (
    <MDTypography component="h6" variant="button" fontWeight="medium" color={textColor}>
      <DropdownButton          
        white
        value={currentBrand?.id?.toString() || "100"}
        onClick={(newValue) => onBrandChange(newValue, currentBrand!)}
        options={allowedBrans.map((item) => ({
          ...item,
          label: item.name || "",
          value: item.id?.toString() || "100"
        }))}
      />
    </MDTypography>
  );
}; 